module.exports = __webpack_public_path__ + "static/media/model-xtrail-t30.6938b4fa.jpg";